// AI Generated Test
import { Component, OnInit, Input } from '@angular/core';
import { PageRepoService } from '@client/app/services/api/page-repo/page-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { HelpCenterRepoService } from '@client/app/modules/data-privacy/services/api/help-center-repo/help-center-repo.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import {
    PrivacyDialogsHelpCenterComponent,
} from '@client/app/modules/data-privacy/dialogs/help-center/help-center.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'privacy-violation-pages',
    standalone: false,
    template: `
        <div class="privacy-violation-pages">
            <div class="mon-dialog-header">
                <page-header
                    [panelClass]="'row'"
                    [header]="infoType.name"
                    [subHeader]="getSubHeader()"
                    [panelLeftClass]="'col-48 pt-2'">
                </page-header>
            </div>

            <div class="mon-dialog-body">
                <div class="mx-4 border-b">
                    <div class="row mx-0">
                        <div class="col-lg-24 py-3">
                            <strong translate>Quick help</strong><br/>
                            <p *ngIf="infoType.description" [innerHTML]="infoType.description"></p>
                            <a class="text-link cursor-pointer" (click)="openHelpCenter(infoType)">
                                <span class="fas fa-graduation-cap"></span>
                                <span translate>Help center</span>
                            </a>
                        </div>
                        <div class="col-lg-24 border-l py-3">
                            <mon-spinner [loading]="loading">
                                <div class="row">
                                    <div class="col-48 pb-3">
                                        <strong><span translate>Compliance</span> {{ compliancePercentage | monNumber:'0%' }}</strong>
                                    </div>
                                    <div class="col-48">
                                        <ngb-progressbar class="data-privacy-compliance-progress-bar"
                                                         [max]="totalPagesCount"
                                                         [value]="pagesDone">
                                        </ngb-progressbar>
                                    </div>
                                    <div class="col-48 mt-2 d-flex flex-wrap">
                                        @let formattedCompliancePercentage = compliancePercentage | monNumber:'0.[00]%';
                                        <div class="mr-auto">
                                            {{ '[[pagesDone]] Pages ([[compliancePercentage]]) in compliance' | translate:'':{pagesDone: pagesDone, compliancePercentage: formattedCompliancePercentage} }}
                                        </div>
                                        @let errorPercentage = (1 - compliancePercentage) | monNumber:'0.[00]%';
                                        <div>
                                            {{ '[[pageIssues]] Pages ([[errorPercentage]]) to fix' | translate:'':{pageIssues: totalPageViolations, errorPercentage } }}
                                        </div>
                                    </div>
                                </div>
                            </mon-spinner>
                        </div>
                    </div>
                </div>
                <div class="card panel-monsido-card mr-3 ml-3">
                    <div class="card-body">
                        <table-container [noResultMessage]="'Good job! No issues were found' | translate"
                             [collection]="pages"
                             (onPageChange)="onPageChange($event)"
                             (onPerPageChange)="onPageSizeChange($event)"
                             [progress]="progress"
                             class="pages-table-wrapper">
                            <table class="table table-hover table-fixed table-with-labels">
                                <thead>
                                    <tr>
                                        <th monTableSort
                                            [monSortBy]="'title'"
                                            [monSortDirection]="currentSort.direction"
                                            [monCurrentlySortedBy]="currentSort.by"
                                            (monOnSorted)="onMonTableSort($event)"
                                            [monThTitle]="'Title and URL' | translate">
                                        </th>
                                        <th *ngIf="!(activeTab === 'pdf' || activeTab === 'document') && viewsColumIsAvailable"
                                            class="table-header-page-views text-right"
                                            monTableSort
                                            [monSortBy]="'hits'"
                                            [monSortDirection]="currentSort.direction"
                                            [monCurrentlySortedBy]="currentSort.by"
                                            (monOnSorted)="onMonTableSort($event)"
                                            [monThTitle]="'Views' | translate">
                                            <span class="outer-l-smurf fas fa-question-circle"
                                                  aria-hidden="true"
                                                  [ngbTooltip]="'Total page views over the last 30 days' | translate"
                                                  [triggers]="'focus hover'">
                                            </span>
                                        </th>
                                        <th class="col-5">&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let page of pages">
                                        <td>
                                            <div class="text-ellipsis">
                                                <mon-url-title
                                                        *ngIf="!pageDetailsIsAvailable"
                                                        [title]="page.title"
                                                        [url]="page.url"
                                                        [active]="false">
                                                </mon-url-title>
                                                <url-title-page-details
                                                        *ngIf="pageDetailsIsAvailable && page.type === 'html'"
                                                        [target]="target"
                                                        [subTarget]="infoType || violation.info_type"
                                                        [page]="page"
                                                        [title]="pageTitle(page.title)"
                                                        [url]="page.url"
                                                        (onClose)="onPageDetailsClose()"
                                                        [active]="true">
                                                </url-title-page-details>
                                                <url-title-document-details *ngIf="pageDetailsIsAvailable && page.type !== 'html'"
                                                                            [document]="page"
                                                                            [title]="pageTitle(page.title)"
                                                                            [url]="page.url"
                                                                            [active]="true"
                                                                            [target]="target"
                                                                            [subTarget]="subTarget">
                                                </url-title-document-details>
                                            </div>
                                            <label-table *ngIf="showLabels"
                                                         [assignedLabels]="page.labels"
                                                         [existingLabels]="labels">
                                            </label-table>
                                        </td>
                                        <td *ngIf="viewsColumIsAvailable"
                                            class="text-v-middle text-right"
                                            [hidden]="activeTab === 'pdf' || activeTab === 'document'">
                                            <visits [visits]="page.hits" [title]="page.title" [totalVisits]="pages.pageHits">

                                            </visits>
                                        </td>
                                        <td class="text-v-middle">
                                            <div class="d-flex align-items-center justify-content-end flex-wrap">
                                                <table-page-details
                                                        *ngIf="page.type === 'html'"
                                                        [ngbTooltip]="'Open page details' | translate"
                                                        [triggers]="'focus hover'"
                                                        [target]="target"
                                                        [subTarget]="infoType || violation.info_type"
                                                        [page]="page"
                                                        [ref]="ref"
                                                        (callBack)="onPageDetailsClose()">
                                                </table-page-details>
                                                <table-document-details
                                                        *ngIf="page.type !== 'html'"
                                                        [ngbTooltip]="'Open document details' | translate"
                                                        [triggers]="'focus hover'"
                                                        [target]="target"
                                                        [document]="page"
                                                        (callBack)="getPage()">
                                                </table-document-details>
                                                <mon-extension-visual-link-button
                                                    class="ml-1"
                                                    [page]="page"
                                                    [type]="issueType">
                                                </mon-extension-visual-link-button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </table-container>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class PrivacyViolationPagesComponent extends BaseContainerComponentController implements OnInit {
    @Input() infoType: any;
    @Input() violation: any;

    viewsColumIsAvailable: boolean = false;
    pageDetailsIsAvailable: boolean = false;
    pages: any = [];
    target: string = 'page-details-section-data-privacy';
    totalPagesCount: number = 0;
    pagesDone: number = 0;
    totalPageViolations: number = 0;
    compliancePercentage: number = 0;
    loading: boolean = false;
    progress: any;
    override activeTab: string = '';
    subTarget: string = '';
    override showLabels: boolean = false;
    override labels: any;
    ref: string = '';
    issueType: string = '';

    constructor (
        private pageRepoService: PageRepoService,
        private translateService: TranslateService,
        private monEventService: MonEventService,
        private helpCenterRepoService: HelpCenterRepoService,
        private activeFeatureService: ActiveFeatureService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.viewsColumIsAvailable = this.activeFeatureService.isFeatureActive('script_setup_guide');
        this.pageDetailsIsAvailable = this.activeFeatureService.isFeatureActive('page_details');
        this.pages = [];
        this.target = 'page-details-section-data-privacy';
        this.currentSort = { by: 'title', direction: 'desc' };
        this.totalPagesCount = 0;
        this.pagesDone = 0;
        this.totalPageViolations = 0;
        this.infoType = this.infoType || this.violation.info_type;
        this.setupTotalPageCount();
        this.getPage();
        this.getDescription();
    }

    override getPage = (): void => {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
        };

        if (this.violation) {
            params.data_protection_violation_id = this.violation.id;
        } else if (this.infoType) {
            params.info_type_id = this.infoType.id;
        }
        this.progress = this.pageGetAll(params).then((pages: any) => {
            this.pages = pages;
        }, () => {});
    };

    pageTitle (title: string): string {
        return title || '(' + this.translateService.getString('No title found') + ')';
    }

    getSubHeader (): string {
        return this.translateService.getString('[[pageCount]] pages found with this issue', {
            pageCount: this.pages.total,
        });
    }

    openHelpCenter (infoType: any): void {
        const params = {
            size: 'lg',
            body: PrivacyDialogsHelpCenterComponent,
            data: { infoType: infoType },
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    getDescription (): void {
        const params = {
            identifier: this.infoType.identifier,
        };

        this.helpCenterRepoService.get(params).then((res: any) => {
            if (Array.isArray(res) && res.length > 0) {
                this.infoType.description = res[0].description;
            }
        });
    }

    override onPageDetailsClose (): void {
        this.getPage();
    }

    setupTotalPageCount (): void {
        this.loading = true;
        let infoTypeId: any;
        let violationId: any;
        if (this.violation) {
            violationId = this.violation.id;
        } else {
            infoTypeId = this.infoType.id;
        }

        Promise.all([this.getPages(), this.getPages(infoTypeId, violationId)])
            .then((values: any) => {
                this.totalPagesCount = parseInt(values[0].total, 10);
                this.totalPageViolations = parseInt(values[1].total, 10);
                this.pagesDone = this.totalPagesCount - this.totalPageViolations;
                this.calculatePercentage();
            }, () => {})
            .finally(() => {
                this.loading = false;
            });
    }

    getPages (infoTypeId?: any, violationId?: any): Promise<any> {
        const params: any = {
            page_size: 1,
            page: 1,
            'types[]': ['html'],
            info_type_id: infoTypeId,
            data_protection_violation_id: violationId,
        };

        return this.pageGetAll(params);
    }

    calculatePercentage (): void {
        this.compliancePercentage = this.pagesDone / this.totalPagesCount || 0;
        if (this.pagesDone > 0 && Math.floor(this.compliancePercentage * 10000) === 0) {
            this.compliancePercentage = 0.0001;
        } else if (this.pagesDone < this.totalPagesCount && Math.ceil(this.compliancePercentage * 10000) === 10000) {
            this.compliancePercentage = 0.9999;
        }
    }

    pageGetAll (params: any): Promise<any> {
        return this.pageRepoService.getAll(params);
    }
}
